import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import { t } from 'i18next'
import { colors } from '../../../styles/colors'
import InformationPopover from '../../InformationPopover/InformationPopover'
import MediaQuery from 'react-responsive'

const StyledBatchKey = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
`
const BatchkeyView = ({ id, batchkey, disabled = false, handleOnChange, handleOnBlur, handleOnKeyDown, formError }) => {

  return (
    <div className="mb-3">
      <Form.Group className="mb-3">
        <Form.Label >{t('createLocalInventory:batchKey')}</Form.Label><MediaQuery minWidth={550}><InformationPopover header={t('createLocalInventory:batchKey')} content={t('withdrawalsTable:batchKeyInfo')} /></MediaQuery>
        {!disabled ?
          <>
            <Form.Control
              id={id}
              name="batchkey"
              placeholder={t('createLocalInventory:batchKey')}
              value={batchkey}
              onChange={handleOnChange}
              onBlur={handleOnBlur}
              onKeyDown={handleOnKeyDown}
              isInvalid={!!formError}
            />
            <Form.Control.Feedback type="invalid">
              {formError}
            </Form.Control.Feedback>
          </>
          : <StyledBatchKey>{batchkey}</StyledBatchKey>
        }
      </Form.Group>
    </div>

  )
}
export default BatchkeyView